import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

const READING_KEYS: readonly [string, string][] = [
  ['J', 'Next row'],
  ['K', 'Previous row'],
  ['Enter', 'What it produced'],
];

const KEYS: readonly [string, string][] = [
  ...READING_KEYS,
  ['A', 'The row’s first action'],
  ['R', 'Rework'],
];

/**
 * The queue's keys, listed (spec 154 FR-020). They work only while focus is
 * in Your turn, so nothing fires while a person types elsewhere.
 *
 * A reader (`canWork` false) is listed only the keys that move and open: A and
 * R do nothing for them (spec 193), and neither does a wait with Undo.
 */
export function KeysHelp({
  canWork = true,
  sectionName = 'Your turn',
}: {
  canWork?: boolean;
  /** The section's heading, for the button's name. */
  sectionName?: string;
}) {
  const keys = canWork ? KEYS : READING_KEYS;
  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            type="button"
            size="icon-xs"
            variant="ghost"
            aria-label={`Keys for ${sectionName}`}
            className="pointer-coarse:size-11"
          />
        }
      >
        <span aria-hidden="true" className="font-mono text-xs font-bold">
          ?
        </span>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-3 text-xs">
        <p className="text-foreground mb-2 font-medium">
          Keys, while a row has focus
        </p>
        <dl className="grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-1.5">
          {keys.map(([key, what]) => (
            <div key={key} className="contents">
              <dt>
                <kbd className="border-border bg-muted rounded border px-1.5 py-0.5 font-mono">
                  {key}
                </kbd>
              </dt>
              <dd className="text-muted-foreground">{what}</dd>
            </div>
          ))}
        </dl>
        {canWork ? (
          <p className="text-muted-foreground mt-2">
            Every action waits 6 seconds, with Undo.
          </p>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
